var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlaySvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.416482 0.966553C0.10412 1.27891 0 1.79952 0 2.42424V25.4349C0 26.0596 0.208241 26.5802 0.520602 26.8926L0.624723 26.9967L13.5357 14.0858V13.8775L0.416482 0.966553Z",
    fill: "url(#paint0_linear_1486_15740)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7006 18.4581L13.4316 14.1892V13.8768L17.7006 9.60791L17.8047 9.71203L22.9066 12.6274C24.3643 13.4604 24.3643 14.8139 22.9066 15.6469L17.7006 18.4581Z",
    fill: "#2A62C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.8042 18.3545L13.4311 13.9814L0.416016 26.9966C0.936621 27.5172 1.66547 27.5172 2.60256 27.1007L17.8042 18.3545Z",
    fill: "url(#paint1_linear_1486_15740)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.8042 9.6081L2.60256 0.966052C1.66547 0.445446 0.936621 0.549567 0.416016 1.07017L13.4311 13.9812L17.8042 9.6081Z",
    fill: "url(#paint2_linear_1486_15740)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M17.7 18.2505L2.60255 26.7884C1.76958 27.309 1.04074 27.2049 0.520137 26.7884L0.416016 26.8925L0.520137 26.9967C1.04074 27.4131 1.76958 27.5173 2.60255 26.9967L17.7 18.2505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M0.416483 26.7883C0.10412 26.476 0 25.9554 0 25.3306V25.4347C0 26.0595 0.208242 26.5801 0.520604 26.8924V26.7883H0.416483ZM22.9066 15.335L17.7006 18.2504L17.8047 18.3545L22.9066 15.4391C23.6354 15.0227 23.9478 14.502 23.9478 13.9814C23.9478 14.502 23.5313 14.9185 22.9066 15.335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M2.60302 1.07035L22.9066 12.6278C23.5313 13.0443 23.9478 13.4607 23.9478 13.9813C23.9478 13.4607 23.6354 12.9401 22.9066 12.5236L2.60302 0.966225C1.14533 0.133258 0 0.757983 0 2.42392V2.52804C0 0.966225 1.14533 0.237379 2.60302 1.07035Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_15740",
    x1: 12.2862,
    y1: 2.22641,
    x2: -5.18836,
    y2: 19.6999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1486_15740",
    x1: 15.4376,
    y1: 16.3721,
    x2: -8.25833,
    y2: 40.0679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1486_15740",
    x1: -2.81486,
    y1: -6.65978,
    x2: 7.76697,
    y2: 3.92204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlaySvg);
export default __webpack_public_path__ + "static/media/GooglePlaySvg.537c3a10a84879d40bfae2fc446a7505.svg";
export { ForwardRef as ReactComponent };